import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { AgendaRoom } from "@domaddress/shared";

export default function HomePage() {
  const [rooms, setRooms] = useState<AgendaRoom[]>([]);

  useEffect(() => {
    void api.get<{ data: AgendaRoom[] }>("/api/rooms").then((r) => setRooms(r.data.data));
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Agenda Dominicus</h1>
          <p className="page-subtitle">
            Eén plek voor evenementen (met zalen), publieke agenda en werkgroep-roosters. De website haalt
            beschikbaarheid op via ICS-feeds per zaal.
          </p>
        </div>
      </div>

      <div className="card">
        <h2>Zalen (ICS voor website)</h2>
        <p className="page-subtitle" style={{ marginTop: 0, marginBottom: "1rem" }}>
          Vervang in WordPress de Google Calendar-URL&apos;s door deze links:
        </p>
        <ul className="agenda-ics-list">
          {rooms.map((r) => (
            <li key={r.id}>
              <span className="room-dot" style={{ background: r.color }} />
              <strong>{r.name}</strong>
              <br />
              <code>
                {import.meta.env.VITE_API_URL ?? window.location.origin}/api/rooms/{r.id}/ics
              </code>
            </li>
          ))}
        </ul>
      </div>

      <p className="agenda-page-links">
        <Link to="/kalender">Kalender (zalen + evenementen) →</Link>
        {" · "}
        <Link to="/evenementen">Evenementen →</Link>
        {" · "}
        <Link to="/roosters">Roosters →</Link>
      </p>
    </div>
  );
}
